import React from 'react';


const RadioButton = ({ id, label, radioValue, input: { value, ...restInput } }) => (
  <div className="field">
    <div className="ui radio checkbox">
      <input 
        {...restInput}
        id={id}
        type="radio"
        value={radioValue}
        checked={radioValue === value}
      />
      <label>{label}</label>
    </div>
  </div>
);


export default RadioButton;
